// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---FycuQ","changedRecordsList":"changedRecordsList---mA0ch","changedRecord":"changedRecord---SLIG1"};